import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../../hooks/useBooking';
import { hexToRgba } from '../../lib/colorUtils';
import { useSiteColors } from '../../hooks/useSiteColors';

// A card in the primary color: all text is onPrimary, and the button inverts it,
// so every pairing here is the graded "button label" contrast.
export function BookingCTABanner() {
  const navigate = useNavigate();
  const { businessListing } = useBooking();
  const c = useSiteColors();

  if (!businessListing) return null;

  const ctaLabel = businessListing.cta_label ?? 'Book Appointment';

  return (
    <section className="py-20">
      <div className="max-w-[1200px] mx-auto px-6">
        <div
          className="rounded-3xl overflow-hidden"
          style={{
            backgroundColor: c.primaryFill,
            border: c.primaryOutline ? `1px solid ${c.primaryOutline}` : undefined,
          }}
        >
          <div className="relative p-12 sm:p-16 text-center">
            <div
              className="absolute top-[-30%] right-[-10%] w-[50%] h-[160%] pointer-events-none"
              style={{ background: `radial-gradient(ellipse, ${hexToRgba(c.onPrimary, 0.12)}, transparent 60%)` }}
            />
            <div className="relative z-10">
              <p className="text-xs font-semibold tracking-[0.15em] uppercase mb-4" style={{ color: c.onPrimary }}>
                Easy Booking
              </p>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight leading-tight mb-4" style={{ color: c.onPrimary }}>
                Ready to book your<br />next appointment?
              </h2>
              <p className="text-base max-w-md mx-auto mb-8" style={{ color: c.onPrimary }}>
                Choose your service, pick a time, and you're all set. No phone calls, no waiting.
              </p>
              <button
                onClick={() => navigate('/book')}
                className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-[15px] font-semibold transition-all hover:-translate-y-0.5"
                style={{ backgroundColor: c.onPrimary, color: c.primaryFill }}
              >
                {ctaLabel}
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
